import React, { Component, Fragment } from 'react';
import './Register.module.scss';
import { connect } from 'react-redux';
import { history } from 'components/App/components/UnauthenticatedApp';

//import components
import DefaultButton from 'components/UI/Button/Button';
import DropDown from 'components/UI/DropDown/DropDown';

import storeUser from 'actions/user/store';
import { notify } from 'reapop';

const mapDispatchToProps = {
    storeUser,
    notify
};

class Register extends Component {

    constructor() {
        super();

        this.state = {
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            organisation: 1,
            license: '',
            newsletter: 0,
            agreeToTerms: false,
            goToForm: false,
            licenceCode: false,
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handlePasswordConfirmationChange = this.handlePasswordConfirmationChange.bind(this);
        this.handleOrganisationChange = this.handleOrganisationChange.bind(this);
        this.handleLicenseChange = this.handleLicenseChange.bind(this);
        this.createUser = this.createUser.bind(this);
        this.goToForm = this.goToForm.bind(this);
        this.goToFormLicense = this.goToFormLicense.bind(this);
        this.handleNewsletterChange = this.handleNewsletterChange.bind(this);
        this.handleTermsChange = this.handleTermsChange.bind(this);
    }
    goToForm() {
        this.setState({
            goToForm: true
        });
    }
    goToFormLicense() {
        this.setState({ 
            goToForm: true, 
            licenceCode: true 
        });
    }
    componentDidMount() {
        if (this.props.match.params.page && this.props.match.params.page == 'proefaccount') {
            return this.setState({
                goToForm: true
            });
        }

        if (this.props.match.params.page && this.props.match.params.page == 'licentiecode') {
            return this.setState({
                goToForm: true,
                licenceCode: true 
            });
        }
    }

    handleNameChange(event) {
        this.setState({ name: event.target.value });
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    handlePasswordConfirmationChange(event) {
        this.setState({ password_confirmation: event.target.value });
    }

    handleOrganisationChange(event) {
        this.setState({ organisation: event.target.value });
    }

    handleLicenseChange(event) {
        this.setState({ license: event.target.value });
    }

    handleNewsletterChange(e) {
        this.setState({ newsletter: !this.state.newsletter });
    }

    handleTermsChange(e) {
        this.setState({ agreeToTerms: !this.state.agreeToTerms });
    }

    createUser() {

        if (!this.state.agreeToTerms) {
            this.props.notify({
                title: 'Er ging iets mis',
                dismissible: true,
                message: 'U moet akkoord gaan met de gebruiksvoorwaarden',
                status: 'error',
                position: 'tc'
            });
            return;
        }

        this.props.storeUser(this.state)
            .then((result) => {
                this.props.notify({
                    title: 'Uw account is geactiveerd, u kunt nu inloggen!',
                    dismissible: true,
                    status: 'success',
                    position: 'tc'
                });
                this.props.history.push('/inloggen');
            });
    }

    render() {
        return (
            <div styleName="register-background">
                <div styleName="top-bar">
                    <img onClick={() => {history.push('/');}} styleName="logo" src='/images/logos/plenda-logo.svg' />
                </div>
                <div styleName='conent-wrap'>
                    <div styleName="content">
                        {
                            (this.state.goToForm == true && this.state.licenceCode == false) ?
                                <Fragment>
                                    <div style={{ width: '300px', padding: '20px 20px 0px 20px' }}>
                                        <label>Bekijk de Plenda Applicatie in vogelvlucht:</label>
                                        <iframe style={{ margin: '20px 0px 40px 0px' }} height="181px" width="100%" src="https://www.youtube.com/embed/z-kC-LlsB4Q" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                        <label>Maak een proefaccount aan:</label>
                                    </div>
                                </Fragment>
                                :
                                <img styleName="mountains-logo" src="/images/mountains.svg" />
                        }
                        

                        {this.state.goToForm == false &&
                    <div styleName='buttons'>
                        <div styleName='box'>
                            <p>Maak een account aan en test 30 dagen gratis de Plenda Applicatie. Vrijblijvend en zonder opzegtermijn.</p>
                            <DefaultButton textStyle={{ alignItems:'center' }} handleClick={this.goToForm} noarrow style={{ borderRadius: '3px',width:'100%', boxSizing:'border-box' }} title="Maak proefaccount aan" type="blue" />
                        </div>
                        <div styleName='box'>
                            <p>Heb je een licentiecode ontvangen? Registreer je dan hier en gebruik de licentiecode.</p>
                            <DefaultButton textStyle={{ alignItems:'center' }} handleClick={this.goToFormLicense} noarrow style={{ borderRadius: '3px',width:'100%', boxSizing:'border-box' }} title="Registreer met licentiecode  " type="blue" />
                        </div>
                    </div>
                        }

                        {this.state.goToForm &&
                    <Fragment>

                        <form styleName="register-form">

                            <label styleName="input-label">Naam</label>
                            <input value={this.state.name} onChange={this.handleNameChange} styleName="input-box" type="text" />

                            <label styleName="input-label">Emailadres</label>
                            <input value={this.state.email} onChange={this.handleEmailChange} styleName="input-box" type="email" />

                            <label styleName="input-label">Wachtwoord</label>
                            <p style={{margin: 0}}>Minimaal 6 tekens</p>
                            <input value={this.state.password} onChange={this.handlePasswordChange} styleName="input-box" type="password" />

                            <label styleName="input-label">Herhaal wachtwoord</label>
                            <input value={this.state.password_confirmation} onChange={this.handlePasswordConfirmationChange} styleName="input-box" type="password" />
                            {this.state.licenceCode &&
                                <Fragment>
                                    <label styleName="input-label">Licentiecode</label>
                                    <input value={this.state.license} onChange={this.handleLicenseChange} styleName="input-box" type="text" />
                                </Fragment>
                            }
                            <label>Gebruiksvoorwaarden</label>
                            <label styleName='checkbox-wrapper'>
                                <input checked={this.state.agreeToTerms} onChange={this.handleTermsChange} type='checkbox'></input>
                                <p>Ik heb de <a target='_blank' download href='/images/gebruiksvoorwaarden_1.1.pdf'>gebruiksvoorwaarden</a> gelezen en ga akkoord</p>
                            </label>
                            <label>Nieuwsbrief</label>
                            <label styleName='checkbox-wrapper'>
                                <input checked={this.state.newsletter} onChange={this.handleNewsletterChange} type='checkbox'></input>
                                <p>Ik schrijf me in voor de Plenda nieuwsbrief met exclusieve kortingsacties en productupdates</p>
                            </label>
                            
                        </form>
                        <div styleName="actions">
                            <DefaultButton handleClick={this.createUser} noarrow style={{ marginTop: '9px', width: '122.77px', borderRadius: '3px' }} title="Account aanmaken" type="blue" />
                        </div>
                    </Fragment>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(Register);